import React, { useState } from 'react'
import AniLink from 'gatsby-plugin-transition-link/AniLink'
import Layout from '../Layout'
import styled from 'styled-components'

//sections

//components
import SEO from '../components/SEO'
import Header from '../components/Header'
import Paragraph from '../components/Paragraph'
import SectionSeparator from '../components/SectionSeparator'
import Masonry from '../components/Masonry'
import Button from '../components/Button'

//images
import BgImage from '../assets/images/terraces/bg-main-2.jpg'
import BgTextured from '../assets/images/bg3.png'
import PorticoLogo from '../assets/images/terraces/portico_gold.png'
import PorticoBg from '../assets/images/terraces/portico_bg.jpg'
import TheRooftopBg from '../assets/images/terraces/rooftop_bg.jpg'
import LeDeckBg from '../assets/images/terraces/ledeck_bg.jpg'
import fiammaI from '../assets/images/terraces/fiamma.jpg'
import boticarioI from '../assets/images/terraces/boticario.jpg'

//gallery portico
import portico1 from '../assets/images/terraces/portico_01.jpg'
import portico2 from '../assets/images/terraces/portico_02.jpg'
import portico3 from '../assets/images/terraces/portico_03.jpg'
import portico4 from '../assets/images/terraces/portico_04.jpg'
import portico5 from '../assets/images/terraces/portico_05.jpg'
import portico6 from '../assets/images/terraces/portico_06.jpg'
// import portico7 from '../assets/images/terraces/portico_07.jpg'
// import portico8 from '../assets/images/terraces/portico_08.jpg'
// import portico9 from '../assets/images/terraces/portico_09.jpg'
// import portico10 from '../assets/images/terraces/portico_10.jpg'
// import portico11 from '../assets/images/terraces/portico_11.jpg'
// import portico12 from '../assets/images/terraces/portico_12.jpg'
// import portico13 from '../assets/images/terraces/portico_13.jpg'
// import portico14 from '../assets/images/terraces/portico_14.jpg'
// import portico15 from '../assets/images/terraces/portico_15.jpg'
// import portico16 from '../assets/images/terraces/portico_16.jpg'
// import portico17 from '../assets/images/terraces/portico_17.jpg'
// import portico18 from '../assets/images/terraces/portico_18.jpg'
// import portico19 from '../assets/images/terraces/portico_19.jpg'

//gallery le deck
import ledeck1 from '../assets/images/terraces/ledeck_01.jpg'

//the rooftop gallery
import therooftop1 from '../assets/images/terraces/therooftop_01.png'
import therooftop2 from '../assets/images/terraces/therooftop_02.jpg'
import therooftop3 from '../assets/images/terraces/therooftop_03.jpg'

const Wrapper = styled.section`
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  min-height: 120vh;
  background: #171717;
  background: top left no-repeat;
  background-image: url(${({ background }) => (background) ? background : '' });
  background-size: cover;
  transition: all 0.3s ease;

  h2 {
    color: #a98e67;
    padding-bottom: 10px;
    font-size: 48px;
  }

  ${({ theme }) => theme.media.l} {
    flex-direction: row;
  }
`

const InnerWrapper = styled.div`
  width: 100%;
  max-width: 1280px;
  max-width: ${({ maxWidth }) => (maxWidth) ? maxWidth : '1280px' };
  margin: auto;
  padding: 80px 30px 100px;
  display: ${({ display }) => (display) ? display : '' };
  align-items: center;
  justify-content: center;
`
const LogoWrapper = styled.div`
  margin-left: -20px;
`

const Content = styled.div`
  padding: 15px;
  width: 50%;
`

const Container = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 100px 30px 100px;
  margin-left: auto;
  margin-right: auto;

  ${({ theme }) => theme.media.m} {
    padding: 140px 30px 100px;
  }

  ${({ theme }) => theme.media.l} {
    padding: 180px 50px 100px;
    padding: 180px ${({ halfWidth }) => (halfWidth ? '50%' : '40%')} 100px 50px;
  }

  ${({ theme }) => theme.media.xl} {
    padding-top: 240px;
  }

  ${({ theme }) => theme.media.xxl} {
    padding-top: 360px;
  }
`
const TerraceDetails = styled.ul`
  padding-left: 20px;
  margin-bottom: 25px;
  li {
    margin-bottom: 10px;
    list-style-type: disc;
    font-size: 14px;
    opacity: 0.6;
  }
`

const TerracesPage = ({ data }) => {

  const [trGalleryPopup, setTrGalleryPopup] = useState(false)
  const [pGalleryPopup, setPGalleryPopup] = useState(false)
  const [ldGalleryPopup, setLdGalleryPopup] = useState(false)
  const [fiammaGalleryPopup, setFiammaGalleryPopup] = useState(false)
  const [boticarioGalleryPopup, setBoticarioGalleryPopup] = useState(false)

  var theRooftopImages = [
    {
      url: therooftop1,
      width: 4,
      height: 3
    },
    {
      url: therooftop2,
      width: 3,
      height: 4
    },
    {
      url: therooftop3,
      width: 4,
      height: 1
    }
  ]

  var porticoImages = [
    {
      url: portico1,
      width: 4,
      height: 3
    },
    {
      url: portico2,
      width: 4,
      height: 3
    },
    {
      url: portico3,
      width: 3,
      height: 4
    },
    {
      url: portico4,
      width: 4,
      height: 3
    },
    {
      url: portico5,
      width: 4,
      height: 3
    },
    {
      url: portico6,
      width: 3,
      height: 4
    },
  ]

  var leDeckImages = [
    {
      url: LeDeckBg,
      width: 3,
      height: 4
    },
    {
      url: ledeck1,
      width: 4,
      height: 3
    }
  ]

  let fiammaImages = [
    {
      url: fiammaI,
      width: 3,
      height: 4
    }
  ]

  let boticarioImages = [
    {
      url: boticarioI,
      width: 3,
      height: 4
    }
  ]

  return (
    <Layout>
      <SEO title="S&S Hospitality | Terraces" canonical="https://www.sandshospitality.com/terraces/" description='Best outdoor restaurant and bars. City views at Alto’s sky-high rooftop. Alluring sunsets at Harbourside Grill. Waterfront terrace at Boticario. Al fresco seating at Portico. Pet-friendly patio dining at Fiamma.' />
      <Wrapper background={BgImage}>
        <Container>
            <Header paddingBottom="30px">Terraces</Header>
            <Paragraph white>
              Showcasing the city's most breath-taking vibes, visuals and vistas, S&S Hospitality's spectacular terraces and rooftops are designed to take your spirits high. They are the centre piece of S&S restaurants and bars with a tranquil yet vibrant atmosphere and spectacular skyline views from sunrise to nightfall, that offer the perfect place for al fresco dining, catching the best sunset, casual gatherings to romantic weddings or engaging events – the perfect choice for Hong Kong's most discerning.
            </Paragraph>
        </Container>
      </Wrapper>
      <Wrapper background={BgTextured}>
          <SectionSeparator />
          <InnerWrapper display="flex">
            <Content>
              <LogoWrapper>
                <img width={300} src={PorticoLogo} alt="Portico logo" />
              </LogoWrapper>
              <Paragraph>
                Between the largest terrace in Central - PORTICO is the adjoining outdoor area of celebrity chef, Enrico Bartolini's authentic Italian restaurant, SPIGA. It is the perfect location for pre-dinner drinks, al fresco dining, relaxing cocktails and an unparalleled event space offering endless possibilities, such as corporate cocktail receptions, wedding ceremonies and much more.
              </Paragraph>
              <Paragraph>
                PORTICO glows in the heart of Hong Kong with its lush greenery creating the illusion of a secret garden oasis. With its intimate dining low tables, couches and a long bar at one end, the terrace affords discrete corners and relaxing private spaces with plants serving as loose space dividers.
              </Paragraph>
              <Paragraph>
                A fun and lively atmosphere for bigger groups and 'chill-out' cocktail parties with weekly live DJ performances and themed parties defines the soul of PORTICO, a perfect escape by day and a throbbing heart-beat of foot-stomping energy by night.
              </Paragraph>
              <TerraceDetails>
                <li>3/F, LHT Tower, 31 Queens Road, Central, Hong Kong.</li>
                <li>Opening hours: Monday to Sunday 11:30am - 12am.</li>
                <li>Reservations: reservations@spiga.com.hk  |  +852 2871 0055</li>
                <li>240 square feet terrace space.</li>
                <li>Seating capacity: 108 (seated); 200 (standing).</li>
              </TerraceDetails>
              <Button onClick={ () => setPGalleryPopup(true) }>Take a tour</Button>
              <Masonry
                small
                active={pGalleryPopup === true}
                handleClose={() => setPGalleryPopup(false)}
                images={porticoImages}
              />
            </Content>
            <Content>
              <img style={{ width: '100%', height: 'auto' }} src={PorticoBg} alt="Portico logo" />
            </Content>
          </InnerWrapper>
          <SectionSeparator />
          <InnerWrapper display="flex">
            <Content>
              <img style={{ width: '100%', height: 'auto' }} src={TheRooftopBg} alt="Portico logo" />
            </Content>
            <Content>
              <h2>The Rooftop</h2>
              <Paragraph>
                Pulse-perfect and picturesque, The Rooftop garners top points as Hong Kong's incomparable terrace venue for events literally on the top of the city! 
              </Paragraph>
              <Paragraph>
                Above ALTO Bar & Grill on the 32nd floor of V Point Tower in Causeway Bay, The Rooftop takes guests to great heights offering unmatched design elements by Tom Dixon and spectacular views of Victoria Harbour – a living, breathing symbol of  infinite opportunities at the Fragrant Harbour of Asia.
              </Paragraph>
              <Paragraph>
                Featuring a wide selection of artisanal cocktails, upbeat live DJ music on the weekends and excellent shisha, The Rooftop is a favourite of socialites, celebrities, corporate elite and romantic couples looking to embrace the inspirational Hong Kong sunset, or a fun-filled night out. 
              </Paragraph>
              <TerraceDetails>
                <li>32/F, V Point, 18 Tang Lung St, Causeway Bay, Hong Kong</li>
                <li>Opening hours: Monday - Sunday: 11:30am until late</li>
                <li>Reservations: reservations@alto.com.hk  |  +852 2603 7181</li>
                <li>Over 2000 square feet rooftop terrace space</li>
                <li>Seating capacity: 100 (seated); 250 (standing)</li>
              </TerraceDetails>
              <Button onClick={ () => setTrGalleryPopup(true) }>Take a tour</Button>
              <Masonry
                small
                active={trGalleryPopup === true}
                handleClose={() => setTrGalleryPopup(false)}
                images={theRooftopImages}
              />
            </Content>
          </InnerWrapper>
          <SectionSeparator />
          <InnerWrapper display="flex">
            <Content>
              <h2>Le Deck</h2>
              <Paragraph>
                The adjoining terrace venue of popular signature restaurant Harbourside Grill – Le Deck – offers incomparable panoramic skyline views and a sensational al fresco dining experience with endless city and sea vistas.
              </Paragraph>
              <Paragraph>
                An exceptional setting for sunset cocktails on the terrace, leisurely lunches and special occasions, Le Deck is your venue of choice. The sophisticated, large outdoor terrace offers custom-made grill menus, relaxing lounge sofas and marble-topped tables to wind down the evening, top-notch entertainment and a wide range of services to suit every taste and occasion. Hong Kong's most exquisite parties, glamorous weddings, product showcases, corporate parties and personal intimate events are hosted with the attention to detail and imaginative flair.  
              </Paragraph>
              <Paragraph>
                View the venue’s stunning photos and visualise your life's next milestone celebrated here at Le Deck.
              </Paragraph>
              <TerraceDetails>
                <li>Shop OTE401, Level 4, Ocean Terminal, Harbour City, Tsim Sha Tsui, Hong Kong</li>
                <li>Opening hours: Monday - Sunday: 12:00pm until late</li>
                <li>Reservations: reservations@harboursidegrill.com.hk  |  +852 2619 9100</li>
                <li>Over 1300 square feet rooftop terrace space</li>
                <li>Seating capacity: 60 (seated); 200 (standing)</li>
              </TerraceDetails>
              <Button onClick={ () => setLdGalleryPopup(true) }>Take a tour</Button>
              <Masonry
                small
                active={ldGalleryPopup === true}
                handleClose={() => setLdGalleryPopup(false)}
                images={leDeckImages}
              />
            </Content>
            <Content>
              <img style={{ width: '100%', height: 'auto' }} src={LeDeckBg} alt="Portico logo" />
            </Content>
          </InnerWrapper>
          <SectionSeparator />
          <InnerWrapper display="flex">
            <Content>
              <img style={{ width: '100%', height: 'auto' }} src={fiammaI} alt="Portico logo" />
            </Content>
            <Content>
              <h2>FIAMMA</h2>
              <Paragraph>
              Nestled in the lush surroundings of the Peak Galleria - the picturesque hills that overlook Hong Kong’s iconic skyline - FIAMMA serves a menu of seasonal-inspired, authentic Italian dishes executed with signature finesse and flair by the restaurant’s culinary director, Chef Enrico Bartolini, an 8 Michelin star awardee. 
              </Paragraph>
              <Paragraph>
              Whether it’s a relaxing morning breakfast, leisurely brunch, fun-filled family lunch, mingling over drinks at the bar or a romantic dinner, our restaurant offers a delectable range of traditional homemade Italian delicacies, which are accentuated by the scenic setting at The Peak.  
              </Paragraph>
              <Paragraph>
              In the spirit and conviviality of an Italian casa, the spacious venue, reminiscent of a verdant garden in a beautiful family home, is the ideal destination for a memorable gathering with family and friends. FIAMMA also welcomes pets, who will have a special, designated spot on our al fresco patio where they will be provided with refreshing water bowls to keep them happy and hydrated. 
              </Paragraph>
              <Button onClick={ () => setFiammaGalleryPopup(true) }>Take a tour</Button>
              <Masonry
                small
                active={fiammaGalleryPopup === true}
                handleClose={() => setFiammaGalleryPopup(false)}
                images={fiammaImages}
              />
            </Content>
          </InnerWrapper>
          <SectionSeparator />
          <InnerWrapper display="flex">
            <Content>
              <h2>Boticario</h2>
              <Paragraph>
              Inspired by Buenos Aires in the 1920s, Boticario is the go-to restaurant hotspot for Argentinian grill and speciality cuisine in Hong Kong.
              </Paragraph>
              <Paragraph>
              Boticario’s menu celebrates “Asado” barbecue culture and traditions that are close to the hearts of Argentinians, while also featuring elements of Latin-inspired comfort food. 
              </Paragraph>
              <Paragraph>
              Our bar’s mantra of “Cures for the Modern Age” taps into the herbal healing heritage of South America’s farmacias through an exotic and authentic selection of eye-catching cocktails that combine traditional herbs, roots, and flowers with a raft of handpicked craft spirits and homemade infusions. With a unique wine and cocktails programme on offer too, get up close and personal with Argentina’s culturally-inspired beverages.
              </Paragraph>
              <Paragraph>
              Our two-storey Argentinian restaurant in the heart of Tsim Sha Tsui, Hong Kong, offers an air of relaxation, making it the ideal destination to escape from the hustle and bustle of the city. With live band performances in the evening, sports broadcast across multiple screens, an outdoor waterfront seating area and a pet-friendly environment, Boticario is the paraíso of Argentinian wining and dining.
              </Paragraph>
              <Button onClick={ () => setBoticarioGalleryPopup(true) }>Take a tour</Button>
              <Masonry
                small
                active={boticarioGalleryPopup === true}
                handleClose={() => setBoticarioGalleryPopup(false)}
                images={boticarioImages}
              />
            </Content>
            <Content>
              <img style={{ width: '100%', height: 'auto' }} src={boticarioI} alt="Portico logo" />
            </Content>
          </InnerWrapper>
          <SectionSeparator />
          <InnerWrapper maxWidth="720px" style={{ textAlign: 'center' }}>
              <Paragraph center>
                For weddings, corporate events, birthdays, anniversary parties and world-class brand launches alike choose these spectacular terraces and rooftops venues for more reasons than meet the eye. These  time-tested venues bring more than just colour, vibrancy and glamour to your events. 
              </Paragraph>
              <AniLink cover direction="down" bg="#171717" to="/events">
                <Button>Plan Your Event</Button>
              </AniLink>
          </InnerWrapper>
      </Wrapper>

    </Layout>
  )
}

export default TerracesPage
